export const FEATURE_FLAG = {
  ACCOUNT_CREATION_FROM_CHECKOUT: 'account_creation_from_checkout',
  ADDRESS_SUGGESTION_JP: 'address_suggestion_jp',
  ADYEN_EU: 'adyen_eu',
  ADYEN_LEGAL_TERMS: 'adyen_legal_terms',
  ALGOLIA: 'algolia',
  ALLIGATOR_BAN: 'alligator_ban',
  BAIDU: 'baidu',
  BOBJ_REST: 'bobj_rest',
  BOUTIQUE_STOCK_AVAILABILITY: 'boutique_stock_availability',
  CARRIER_ADDRESS_VALIDATION: 'carrier_address_validation',
  CHECKOUT_INLINE_ADDRESS_FORM: 'checkout_inline_address_form',
  DISABLE_FILTERS_NO_RESULTS: 'disable_filters_no_results',
  DISPLAY_CITES_LINK_ON_PRODUCT_PAGE: 'display_cites_link_on_product_page',
  DISPLAY_DISCLAIMER_PIN_CODE: 'display_disclaimer_pin_code_on_sign_up',
  DISPLAY_PIPL_CBDT_CONSENT_CHECKBOX: 'display_pipl_cbdt_consent_checkbox',
  DISPLAY_PRICES: 'display_prices',
  ECOM: 'ecom',
  ENGRAVING: 'engraving',
  FORCE_RENDEZ_VOUS: 'force_rendez_vous',
  GEMINI_CN: 'gemini_cn',
  GEMINI_KR: 'gemini_kr',
  GEMINI_MEIA: 'gemini_meia',
  GEMINI_TW: 'gemini_tw',
  GUEST_ORDER_TOKEN_REQUEST: 'guest_order_token_request',
  HK_NEW_FORM: 'hk_new_form',
  KOREAN_POST: 'korean_post',
  LIGHT_ECOM: 'light_ecom',
  LIMITED_EDITION_NUMBER: 'limited_edition_number',
  MY_ACCOUNT: 'my_account',
  ONLINE_PAYMENT: 'online_payment',
  ORDER_CANCELLATION: 'order_cancellation',
  ORDER_REFUND_EXCHANGE: 'order_refund_exchange',
  PLACES_AUTOCOMPLETE_API: 'places_autocomplete_api',
  STOCK_NOTIFICATION: 'stock_notification',
  SWSE_NEWSLETTER: 'swse_newsletter',
  WEBOUTIQUE_CTA_ON_PRODUCT_PAGE: 'weboutique_cta_on_product_page',
  PASSWORD_RULE_FEBRUARY_2025: 'password_rule_february_2025',
};

export function getFeatureFlag(name) {
  return !!window.Phoenix.featureFlags[name];
}
